// src/components/FeaturesSection.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FeatureCard from './ui/FeatureCard'; // <--- IMPORTAMOS NUESTRO COMPONENTE REUTILIZABLE
// Importamos los iconos de FontAwesome que equivalen a los de react-icons que usabas
import {
    faUtensils,        // Equivalente a FaUtensils
    faDumbbell,        // Equivalente a FaDumbbell (o considera faWeightHanging)
    faCameraRetro,     // Equivalente a FaCamera (o FaImage si quieres algo más genérico)
    faListAlt,       // Equivalente a FaChartBar para "Smart Grocery Lists" (o faShoppingCart)
    faLightbulb,       // Equivalente a FaMagic o para "AI Coach" (o faBrain)
    faSeedling,        // Equivalente a FaLeaf
    faUserShield,       // Equivalente a FaShieldAlt
    faBrain,           // Equivalente a FaMagic para "AI Coach"
    // FaGlobe no tiene un equivalente directo tan obvio, podrías usar faMapMarkedAlt o faLanguage
    // FaMagic también puede ser faWandMagicSparkles
} from '@fortawesome/free-solid-svg-icons';

const FeaturesSection = () => {
    const appName = "MyFit Menu AI"; // Mantén tu nombre de app

    const featuresData = [
        {
            id: "recipeGenerator", // Añadir un ID único es buena práctica
            icon: faUtensils,     // <--- CAMBIO a FontAwesome
            title: "AI Recipe Generator",
            text: `Instantly create recipes that match your taste, culture, and goals. Our AI chef gets to know you—and cooks just like you love it.`
        },
        {
            id: "mealPlanning",
            icon: faDumbbell,   // <--- CAMBIO a FontAwesome (originalmente FaUtensils, ajustado para que no se repita)
            // Si era faUtensils para Meal Planning y Recipe Generator, necesitas distinguir
            // Podrías usar faCalendarAlt o faClipboardList para Meal Planning
            title: "Personalized Meal Planning",
            text: `Build meal plans that fit your health goals, dietary restrictions, allergies, and preferences. ${appName}'s AI takes care of the hard part—so you can just eat well.`
        },
        {
            id: "globalCuisine",
            icon: faUtensils,    // <--- CAMBIO a FontAwesome (originalmente FaGlobe, podrías usar faMapMarkedAlt si es más sobre mapas)
            title: "Global Cuisine, Local Flavor",
            text: `Enjoy authentic international dishes tailored to your cultural background and lifestyle. Diversity and flavor, reimagined for you by ${appName}.`
        },
        {
            id: "imageScanner",
            icon: faCameraRetro, // <--- CAMBIO a FontAwesome (originalmente FaImage)
            title: "Food Image Nutrition Scanner",
            text: `Just snap a photo and let ${appName}'s AI break down the nutritional content. Know exactly what you're eating—anytime, anywhere.`
        },
        {
            id: "groceryLists",
            icon: faListAlt,     // <--- CAMBIO a FontAwesome (originalmente FaChartBar)
            title: "Smart Grocery Lists",
            text: "Save money and time with dynamic shopping lists that sync to your meal plan and local deals. Shop with purpose."
        },
        {
            id: "leftoverMakeover",
            icon: faLightbulb,   // <--- CAMBIO a FontAwesome (originalmente FaMagic)
            title: "Leftover Makeover",
            text: `Turn leftovers into exciting new meals. Reduce waste, save money, and get creative—all powered by AI suggestions from ${appName}.`
        },
        {
            id: "aiCoach",
            icon: faBrain,        // <--- CAMBIO a FontAwesome (originalmente FaMagic)
            title: `Your AI Nutrition Coach by ${appName}`,
            text: "Get instant answers, daily tips, and tailored advice from your smart food assistant. It's like having a personal nutritionist in your pocket—24/7."
        },
        {
            id: "progressTracking",
            icon: faSeedling,    // <--- CAMBIO a FontAwesome (originalmente FaLeaf)
            title: "Progress You Can See",
            text: `Track your health journey with insightful charts and personalized stats in ${appName}. Stay motivated as you hit every milestone.`
        },
        {
            id: "dataProtected",
            icon: faUserShield, // <--- CAMBIO a FontAwesome (originalmente FaShieldAlt)
            title: "Your Data, Protected",
            text: `We use only verified nutritional databases and enforce strict privacy practices. Your health, your rules with ${appName}—secure and reliable.`
        }
    ];


    return (
        <section className="features py-5"> {/* Mantienes tu clase de sección */}
            <Container>
                <Row className="text-center mb-5">
                    <Col>
                        <h2 className="fw-bold display-5">
                            Smarter Eating & Training Starts Here
                        </h2>
                        <p className="text-muted fs-5">
                            Discover how AI-powered nutrition can transform your health, save you time, and make every bite count—tailored just for you by {appName}.
                        </p>
                    </Col>
                </Row>

                <Row className="g-4 justify-content-center"> {/* g-4 para espaciado, justify-content-center si son menos de 3 por fila y quieres centrarlos */}
                    {featuresData.map((feature) => (
                        <Col md={6} lg={4} key={feature.id} className="mb-4 d-flex">
                            <FeatureCard
                                icon={feature.icon}
                                title={feature.title}
                                text={feature.text}
                                // Estas props tienen valores por defecto en FeatureCard.jsx,
                                // puedes sobreescribirlas si necesitas un estilo diferente para esta sección:
                                // iconSize="2x" 
                                // iconContainerClass="icon-circle bg-success text-white mb-3 mx-auto"
                                // cardClassName="h-100 text-center shadow-sm border-0 p-3" // Nota: tu original tenía solo <Card className="h-100 shadow-sm border-0">
                                // titleAs="h5" // Tu original usaba h5
                                // titleClassName="fw-bold mb-3" // Tu original usaba mb-3 en el título
                                // textClassName="text-muted" // Tu original no tenía "small" aquí

                                // Ejemplo de cómo podrías pasar las props para que se parezca más a tu "antiguo" estilo:
                                cardClassName="h-100 shadow-sm border-0" // Sin el padding p-3 global
                                titleAs="h5"
                                titleClassName="fw-bold mb-3"
                                textClassName="text-muted"
                                iconContainerClass="text-success mb-3" // Quitando el círculo y el fondo, solo color al icono y margen
                                iconSize="3x" // Los iconos de react-icons/fa eran size 48, "3x" en FA es similar
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
            {/* Los estilos CSS globales para .feature-card-reusable:hover y opcionalmente .icon-circle
                 deben estar en tu archivo CSS principal si los mantienes/usas. */}
        </section>
    );
};

export default FeaturesSection;